import React from 'react';
import Icon from '../../../components/AppIcon';

const FolderBreadcrumb = ({ currentPath, onNavigate }) => {
  const pathSegments = currentPath?.split('/')?.filter(Boolean);

  return (
    <div className="bg-card border-b border-border px-4 py-3">
      <div className="flex items-center gap-2 overflow-x-auto">
        <button
          onClick={() => onNavigate('/')}
          className="flex items-center gap-2 px-3 py-1.5 rounded-lg hover:bg-muted transition-all duration-250 flex-shrink-0"
        >
          <Icon name="Home" size={16} className="text-muted-foreground" />
          <span className="caption font-medium text-foreground">All Assets</span>
        </button>

        {pathSegments?.map((segment, index) => {
          const path = '/' + pathSegments?.slice(0, index + 1)?.join('/');
          const isLast = index === pathSegments?.length - 1;

          return (
            <React.Fragment key={path}>
              <Icon name="ChevronRight" size={16} className="text-muted-foreground flex-shrink-0" />
              <button
                onClick={() => onNavigate(path)}
                className={`px-3 py-1.5 rounded-lg transition-all duration-250 flex-shrink-0 ${
                  isLast
                    ? 'bg-primary/10 text-primary font-medium' :'hover:bg-muted text-muted-foreground'
                }`}
              >
                <span className="caption">{segment}</span>
              </button>
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default FolderBreadcrumb;